import { IApplicationState } from '../../../types/types';
import { ERoutes } from '../constants';
import { TCommentId } from '../../model/card/types/IComment';

export const getEditCommentId = (
    state: IApplicationState
): TCommentId => {
    const { route, args } = state.router;

    let commentId = null;

    if (ERoutes.EDIT_CARD === route) {
        commentId = args[3];
    } else if (        [
        ERoutes.LINK_CARD,
        ERoutes.ASSIGNED_TO_ME_CARD,
        ERoutes.ASSIGNED_TO_ME_NOTIFICATION,
        ERoutes.ASSIGNED_TO_ME_WORK
    ].includes(route)) {
        commentId = args[2];
    }

    return commentId && parseInt(commentId);
}
